/* Bystella navbar — mark "Bästsäljare" / "Bestsellers" links anywhere in the
   header (top-level menu AND the mobile drawer) so CSS can colorize them.

   The mega-menu cards themselves are rendered by Horizon's mega-menu-list
   snippet when the merchant picks "Bystella – text links + 3 image cards" in
   the Meny block's "Submenu function" dropdown. */
(function () {
  const HIGHLIGHT_LABELS = new Set(['Bästsäljare', 'Bestsellers', 'Bestseller']);

  function mark(root) {
    if (!root) return 0;
    let n = 0;
    root.querySelectorAll('a').forEach((a) => {
      if (a.dataset.bystellaHighlight) return;
      const label = (a.textContent || '').trim();
      if (HIGHLIGHT_LABELS.has(label)) {
        a.setAttribute('data-bystella-highlight', 'bestseller');
        n++;
      }
    });
    return n;
  }

  function run() {
    const root = document.querySelector('#header-component');
    if (!root) return;
    mark(root);
  }

  function init() {
    // Run immediately + after a few frames so we cover the case where Horizon's
    // custom elements (header-drawer / menu-drawer / header-menu) rebuild
    // their internal DOM during hydration and replace already-marked nodes.
    run();
    requestAnimationFrame(run);
    setTimeout(run, 100);
    setTimeout(run, 600);

    // And watch for editor reloads + any later DOM swaps in the header.
    const root = document.querySelector('#header-component');
    if (root) {
      const obs = new MutationObserver(run);
      obs.observe(root, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
